import { makeAutoObservable } from 'mobx';
import { validateCandleBreak } from './validateCandleBreak';

export class CandleBreakData {
  candleDuration = 1;
  quantityBasisValue = 0;
  waitUntilCurrentCandleCloses = false;
  breakBy = 0;

  constructor(initialData) {
    makeAutoObservable(this);
    if (initialData) {
      Object.keys(initialData).forEach(
        (field) => (this[field] = initialData[field])
      );
    }
  }

  //common methods
  resetToDefaults = () => {
    this.candleDuration = 1;
    this.quantityBasisValue = 0;
    this.waitUntilCurrentCandleCloses = false;
    this.breakBy = 0;
  };
  updateTactic = (dataObj) => {
    for (const key in dataObj) {
      this[key] = dataObj[key];
    }
  };

  validate = () => {
    const data = {
      candleDuration: this.candleDuration,
      quantityBasisValue: this.quantityBasisValue,
    };
    const result = validateCandleBreak(data);
    return result;
  };
  returnJson = () => {
    return {
      candleDuration: this.candleDuration,
      quantityBasisValue: this.quantityBasisValue,
      waitUntilCurrentCandleCloses: this.waitUntilCurrentCandleCloses,
      breakBy: this.breakBy,
    };
  };

  //specific methods
  setCandleDuration = (number) => {
    this.candleDuration = number;
  };
  setQuantityBasisValue = (number) => {
    this.quantityBasisValue = number;
  };
  setWaitUntilCurrentCandleCloses = (bool) => {
    this.waitUntilCurrentCandleCloses = bool;
  };
  setBreakBy = (number) => {
    this.breakBy = number;
  };
}
